import { projects, stats } from "@/mocks/homeData";
import { useInView } from "@/hooks/useInView";

export default function ProjectsSection() {
  const { ref, inView } = useInView();

  return (
    <section id="projects" ref={ref} className="relative py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className={`mb-14 md:mb-20 ${inView ? "animate-in" : "opacity-0"}`}>
          <p className="text-secondary-600 text-xs md:text-sm font-medium tracking-widest uppercase mb-4">
            / 精选案例
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight max-w-2xl">
            我们引以为傲的
            <br />
            <span className="italic font-serif text-primary-600">项目作品</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-16 md:mb-20">
          {projects.map((project, idx) => (
            <div
              key={project.id}
              className={`group relative rounded-2xl overflow-hidden cursor-pointer ${project.color} ${
                inView ? `animate-in animate-in-delay-${idx + 1}` : "opacity-0"
              }`}
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 bg-gradient-to-t from-black/60 via-black/30 to-transparent">
                <span className="inline-block px-2.5 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium mb-2">
                  {project.category}
                </span>
                <h3 className="font-heading text-white text-lg md:text-xl font-bold">
                  {project.title}
                </h3>
                <p className="text-white/70 text-xs md:text-sm mt-1">
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className={`grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 ${inView ? "animate-in animate-in-delay-3" : "opacity-0"}`}>
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary-600">
                {stat.value}
                <span className="text-xl md:text-2xl text-primary-400">{stat.suffix}</span>
              </div>
              <p className="text-foreground-400 text-xs md:text-sm mt-2 font-medium">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}